import { Box, Container, Typography } from '@mui/material';
import { ArchiveHospitalManagement } from 'components/templates';
import React from 'react';

export const ArchiveHospitalsAndClinics = () => {
  return (
    <Container component="main" maxWidth="xl" sx={{ width: '75%' }}>
      <Box>
        <Typography variant="h4" component="h1" gutterBottom sx={{ textAlign: 'left' }}>
          Archive Hospitals and Clinics
        </Typography>
      </Box>
      <ArchiveHospitalManagement />
    </Container>
  );
};
